import openaiIcon from "../../assets/svg/openai.svg";
import geminiIcon from "../../assets/svg/gemini.svg";
import metaIcon from "../../assets/svg/meta.svg";
import copilotIcon from "../../assets/svg/copilot.svg";
import { Check as CheckIcon } from "lucide-react";
import PropTypes from "prop-types";


const MODEL_META = {
  gen4_turbo: { icon: openaiIcon, disabled: false },
  KLING_O1: { icon: copilotIcon, disabled: false },
  MOTION_1_0: { icon: geminiIcon, disabled: false },
  KLING_2_5: { icon: metaIcon, disabled: false },
  VEO3: { icon: geminiIcon, disabled: false },
  "gpt-4.1-mini": { icon: geminiIcon, disabled: false },
  nano_banana: { icon: metaIcon, disabled: false },
  nano_banana_pro: { icon: geminiIcon, disabled: false },
  leonardo_vision_xl: { icon: metaIcon, disabled: false },
  SDXL_1_0: { icon: geminiIcon, disabled: false },
};

export default function DaburModel({
  isMobile,
  sidebarOpen,
  modelSelectorConfig,
  setIsOpen
}) {
  const { modelName, onModelChange, modelOptions, modelList = [] } = modelSelectorConfig;

  const modelsToRender =
    modelList && modelList.length > 0
      ? modelList.map((m) => ({
        key: m.modelKey,
        label: m.modelName,
        image: m.modelImage,
        description:m.description,
        modelId:m.modelId
      }))
      : Object.keys(modelOptions || {}).map((key) => ({
        key,
        label: modelOptions[key],
        image: null,
      }));

  return (
    <div
      className={`absolute ${isMobile && !sidebarOpen
          ? "ml-2 min-w-[240px]"
          : "ml-[16rem] min-w-[240px]"
        } top-[50px] left-1 shadow z-[100] rounded-[14px] bg-[#f9f9f9] border p-2`}
    >
      <div className="flex flex-col gap-1">
        {modelsToRender.map((model) => {
          const key = model.key;
          const isSelected = modelName === key;
          const meta = MODEL_META[key] || {};
          const disabled = meta.disabled || false;
          const icon = model.image || meta.icon || openaiIcon;
          const modelId = model?.modelId || "gpt-5.5"
          const description = model?.description || ""

          return (
            <div
              key={key}
              onClick={() => {
                if (disabled) return;
                onModelChange(key);
                setIsOpen(false);
              }}
              className={`rounded-lg flex items-center p-[5px] gap-2
                ${isSelected ? "bg-[#1B5C2926]" : "bg-[#f9f9f9]"}
                ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer hover:bg-[#1B5C2914]"}
              `}
            >
              <div className="w-[30px] h-[30px] border rounded-2xl flex items-center justify-center">
                <img
                  src={icon || openaiIcon}
                  alt="icon-image"
                  onError={(e) => {
                    e.currentTarget.onerror = null; // prevent infinite loop
                    e.currentTarget.src = openaiIcon;
                  }}
                />

              </div>

              <div className="flex-1 flex justify-between items-center">
                <div className="flex flex-col">
                <span className="truncate text-[13px] pt-[4px]">
                  {/* {modelOptions[key]}- */}
                  {modelId.charAt(0).toUpperCase() + modelId.slice(1)}
                </span>
                <p className="text-[10px] text-gray-500">
                  {description}
                </p>
                </div>

                {isSelected && (
                  <CheckIcon size={20} color="#000000" className="w-5 h-4" />
                )}

                {disabled && (
                  <span className="bg-[#1B5C2926] text-[9px] rounded-md px-1 py-1">
                    coming soon!
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


DaburModel.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
};